export default "/images/vendor/flag-icon-css/flags/4x3/ae.svg?2c530f6449f3e5abd04b2df6be77ee0a";